document.addEventListener("DOMContentLoaded", function () {
  const allSwatches = document.querySelectorAll(".swatch-custom");

  allSwatches.forEach(swatch => {
    const label = swatch.querySelector(".form__label-combined");
    if (!label || !label.textContent.includes("Metal")) return;

    const desiredOrder = [
      "Sterling Silver",
      "14K Yellow Gold",
      "14K White Gold",
      "14K Rose Gold",
      "Platinum 950"
    ];

    const list = swatch.querySelector("ul");
    const items = Array.from(list.querySelectorAll(".item-custom"));

    // Sort based on gemstone name
    items.sort((a, b) => {
      const aText = a.querySelector(".gemstone-name").textContent.trim();
      const bText = b.querySelector(".gemstone-name").textContent.trim();
      return desiredOrder.indexOf(aText) - desiredOrder.indexOf(bText);
    });

    // Re-append sorted items
    items.forEach(item => list.appendChild(item));
  });
});
